import { MentionsType } from '@shared/components/Editor/util/Mentions.util'

import { UserQueries } from '@/graphql/queries/user.queries'

import { useGraphql } from '../useGraphql'

export const useMissionControlUsers = () => {
  const { data } = useGraphql<UserQueries.GET_INTERNAL_USERS.Response>(
    UserQueries.QUERY_KEYS.getMissionControlUsers,
    UserQueries.getMissionControlUsers(),
    {
      limit: 500,
    },
  )

  const authorizedUsers: MentionsType[] = data?.authorizedUsers
    ? data?.authorizedUsers.map((authorizedUser) => {
        return { label: authorizedUser.fullName + '', value: authorizedUser.id }
      })
    : []
  return { authorizedUsers }
}
